import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

/**
 * Minimal PL | EN toggle. Text only, subtle, no dropdown.
 * Variant `top-right` is positioned absolutely for onboarding.
 */
export function LanguageToggle({ variant = "inline", className = "" }) {
  const { language, setLanguage } = useI18n();

  const wrapper =
    variant === "top-right"
      ? `absolute top-5 right-5 z-10 ${className}`
      : className;

  return (
    <div
      className={`flex items-center gap-1 text-sm select-none ${wrapper}`}
      data-testid="language-toggle"
      role="group"
      aria-label="Language selector"
    >
      <LangButton
        active={language === "pl"}
        onClick={() => setLanguage("pl")}
        code="pl"
      />
      <span className="text-white/25">|</span>
      <LangButton
        active={language === "en"}
        onClick={() => setLanguage("en")}
        code="en"
      />
    </div>
  );
}

function LangButton({ active, onClick, code }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`language-toggle-${code}`}
      aria-pressed={active}
      className={`px-1.5 py-1 rounded-md transition-colors duration-200 font-medium ${
        active
          ? "text-[#F4C95D]"
          : "text-white/50 hover:text-white/80"
      }`}
    >
      {code.toUpperCase()}
    </button>
  );
}
